<template>
  <div class="pages" :style="{ height: fixedHeight + 'px' }">
    <!-- 左侧表单 -->
    <div class="pageLeft">
      <div class="titleView">
        <div class="line"></div>
        <div class="titleName">活动规则</div>
      </div>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm"
        id="addHuodong"
        size="small"
      >
        <el-form-item
          label="活动类型"
          prop="activity_type"
          label-width="100px"
          class="mt20"
        >
          <el-radio-group
            v-model="ruleForm.activity_type"
            @change="handleActivityTypeClick"
          >
            <el-radio label="2">消费</el-radio>
            <el-radio label="1">充值</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="活动名称"
          prop="name"
          class="w300"
          label-width="100px"
        >
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入活动名称"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="活动权重"
          prop="auto_matching"
          label-width="100px"
          v-if="ruleForm.activity_type == '2'"
        >
          <el-radio-group v-model="ruleForm.auto_matching">
            <el-radio label="0">无</el-radio>
            <el-radio label="1">一级</el-radio>
            <el-radio label="2">二级</el-radio>
            <el-radio label="3">三级</el-radio>
            <el-radio label="4">四级</el-radio>
            <el-radio label="5">五级</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="顾客类型"
          prop="activity_user"
          label-width="100px"
          v-if="ruleForm.activity_type == '2'"
        >
          <el-radio-group v-model="ruleForm.activity_user">
            <el-radio label="0">全部</el-radio>
            <el-radio label="1">普通会员</el-radio>
            <el-radio label="2">充值会员</el-radio>
            <el-radio label="3">散客</el-radio>
            <el-radio label="4">员工</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="员工类型"
          prop="staff_type"
          label-width="100px"
          v-if="ruleForm.activity_user == '4'"
        >
          <el-checkbox-group v-model="ruleForm.staff_type">
            <el-checkbox label="1">在职员工</el-checkbox>
            <el-checkbox label="2">离职员工</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="是否新人专享"
          prop="new_member"
          label-width="100px"
        >
          <el-radio-group v-model="ruleForm.new_member">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="是否花生宠物主"
          prop="hs_master"
          label-width="110px"
        >
          <el-radio-group v-model="ruleForm.hs_master">
            <el-radio label="0">全部</el-radio>
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="宠物购买"
          prop="pet_buy_item"
          label-width="110px"
        >
          <el-radio-group v-model="ruleForm.pet_buy_item">
            <el-radio label="0">不限</el-radio>
            <el-radio label="1">裸宠</el-radio>
            <el-radio label="2">百天购宠</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="医疗选项" prop="new_member" label-width="100px">
          <el-radio-group v-model="ruleForm.medical_param">
            <el-radio label="0">不限</el-radio>
            <el-radio label="1">百天保障</el-radio>
            <el-radio label="2">万元医疗</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="参与次数"
          prop="new_member"
          label-width="100px"
          v-if="ruleForm.activity_type == '2'"
        >
          <el-input-number
            v-model="ruleForm.use_count"
            :min="0"
            size="small"
            :step-strictly="true"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="活动地点"
          prop="activity_model"
          label-width="100px"
        >
          <el-radio-group v-model="ruleForm.activity_model">
            <el-radio label="0">不限</el-radio>
            <el-radio label="2">线下</el-radio>
            <el-radio label="1">线上</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="适用门店" prop="shop_id" label-width="100px">
          <el-checkbox-group v-model="ruleForm.shop_id">
            <el-checkbox label="5e9412e0b2bfbc089daerr12">金水区店</el-checkbox>
            <el-checkbox label="5e9412e0b2bfbc089daerr17"
              >线上旗舰店</el-checkbox
            >
            <el-checkbox label="5e9412e0b2bfbc089daerr18">郑东新区店</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="活动时间" prop="activity_time" label-width="100px">
          <el-date-picker
            v-model="ruleForm.activity_time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动说明" prop="remark" label-width="100px">
          <el-input
            type="textarea"
            v-model="ruleForm.remark"
            resize="none"
            style="width: 600px"
            rows="4"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="活动类型"
          prop="consume_type"
          label-width="100px"
          v-if="ruleForm.activity_type == '2'"
        >
          <el-radio-group
            v-model="ruleForm.consume_type"
            @change="handelConsumeTypeClick"
          >
            <el-radio label="1">满减</el-radio>
            <el-radio label="2">满赠</el-radio>
            <el-radio label="3">折扣</el-radio>
            <el-radio label="4">立减</el-radio>
            <el-radio label="5">特价</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 活动规则 -->
        <div class="typeView" v-if="ruleForm.activity_type == '2'">
          <!-- 满减 -->
          <div class="reduction" v-if="ruleForm.consume_type == 1">
            <el-form-item prop="name" label="满" label-width="100px">
              <el-row>
                <el-col :span="5">
                  <el-input
                    v-model="ruleForm.fullReductionCon"
                    style="width: 120px"
                    placeholder="请输入金额"
                    size="small"
                  ></el-input>
                </el-col>
                <el-col :span="2" style="text-align: center">减</el-col>
                <el-col :span="5">
                  <el-input
                    v-model="ruleForm.fulleductionValue"
                    style="width: 120px"
                    placeholder="请输入金额"
                    size="small"
                  ></el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <!-- 满赠 -->
          <div class="reduction" v-if="ruleForm.consume_type == 2">
            <div class="reductionTabs">
              <div
                :class="reductionTabs == 1 ? 'reductionActive' : ''"
                @click="reductionTabs = 1"
              >
                金额
              </div>
              <div
                :class="reductionTabs == 2 ? 'reductionActive' : ''"
                @click="reductionTabs = 2"
              >
                数量
              </div>
            </div>
            <el-form-item
              prop="name"
              label="满"
              label-width="100px"
              v-if="reductionTabs == 2"
            >
              <el-row>
                <el-col :span="5">
                  <el-input
                    v-model="ruleForm.fullGiveNum"
                    style="width: 120px"
                    placeholder="请输入数量"
                    size="small"
                  ></el-input>
                </el-col>
                <el-col :span="6" style="text-align: center"
                  >赠商品(请选择赠送商品)</el-col
                >
              </el-row>
            </el-form-item>
            <el-form-item
              label="满"
              prop="name"
              label-width="100px"
              v-if="reductionTabs == 1"
            >
              <el-row>
                <el-col :span="5">
                  <el-input
                    v-model="ruleForm.fullGiveMoney"
                    style="width: 120px"
                    placeholder="请输入金额"
                    size="small"
                  ></el-input>
                </el-col>
                <el-col :span="6" style="text-align: center"
                  >赠商品(请选择赠送商品)</el-col
                >
              </el-row>
            </el-form-item>
          </div>
          <!-- 折扣 -->
          <el-form-item
            label="折扣:"
            label-width="100px"
            v-if="ruleForm.consume_type == 3"
          >
            <el-row>
              <el-col :span="5">
                <el-input
                  v-model="ruleForm.discountValue"
                  style="width: 120px"
                  placeholder="请输入折扣"
                  size="small"
                ></el-input>
              </el-col>
              <!-- <el-col :span="2" style="text-align: center;">折</el-col> -->
              <el-col :span="4" style="text-align: center"
                >{{
                  ruleForm.discountValue == ""
                    ? ""
                    : (ruleForm.discountValue * 10).toFixed(1)
                }}折</el-col
              >
            </el-row>
          </el-form-item>
          <!-- 立减 -->
          <el-form-item
            label="立减:"
            label-width="100px"
            v-if="ruleForm.consume_type == 4"
          >
            <el-row>
              <el-col :span="6">
                <el-input
                  v-model="ruleForm.minusValue"
                  style="width: 140px"
                  placeholder="请输入立减金额"
                  size="small"
                ></el-input>
              </el-col>
              <el-col :span="2" style="text-align: center">元</el-col>
            </el-row>
          </el-form-item>
          <!-- 特价 -->
          <el-form-item
            label="特价:"
            label-width="100px"
            v-if="ruleForm.consume_type == 5"
          >
            <el-row>
              <el-col :span="6">
                <el-input
                  v-model="ruleForm.specialValue"
                  style="width: 140px"
                  placeholder="请输入特价金额"
                  size="small"
                ></el-input>
              </el-col>
              <el-col :span="2" style="text-align: center">元</el-col>
            </el-row>
          </el-form-item>
        </div>
        <!-- 充值 -->
        <div class="reduction" v-if="ruleForm.activity_type == '1'">
          <el-form-item label="充" label-width="100px">
            <el-row>
              <el-col :span="5">
                <el-input
                  v-model="ruleForm.rechangePrice"
                  style="width: 120px"
                  placeholder="请输入金额"
                  size="small"
                ></el-input>
              </el-col>
              <el-col :span="7" style="text-align: center"
                >赠商品(请选择赠送商品)</el-col
              >
              <!-- <el-col :span="2" style="text-align: center;">赠</el-col> -->
              <!-- <el-col :span="5">
								<el-input v-model="ruleForm.rechangeGive" style="width: 120px;" placeholder="请输入金额"></el-input>
							</el-col> -->
            </el-row>
          </el-form-item>
        </div>
        <el-form-item
          label="支付方式"
          prop="pay_type"
          label-width="100px"
          v-if="ruleForm.activity_type == '2'"
        >
          <el-checkbox-group v-model="ruleForm.pay_type" @change="changeType">
            <el-checkbox label="7" :disabled="disabled">余额</el-checkbox>
            <el-checkbox label="-1" :disabled="disabled">非余额</el-checkbox>
            <el-checkbox label="11">第三方</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <!-- 右侧添加商品和赠品 -->
    <div class="pageRight">
      <div class="pageRightView">
        <!-- 添加商品 -->
        <div
          class="shopView"
          v-if="ruleForm.activity_type == '2'"
          style="margin-bottom: 20px"
        >
          <div class="titleView">
            <div class="line"></div>
            <div class="titleName">添加产品</div>
          </div>
          <el-radio-group
            v-model="ruleForm.shopType"
            class="mt20"
            @change="handelShopTypeClick"
          >
            <el-radio label="0">全部商品</el-radio>
            <el-radio label="1">品牌</el-radio>
            <el-radio label="2">商品类目</el-radio>
            <el-radio label="3">指定商品</el-radio>
            <el-radio label="4">指定活体</el-radio>
            <el-radio label="5">活体年龄</el-radio>
          </el-radio-group>
          <!-- 选择类目 -->
          <div class="com" v-if="ruleForm.shopType == 2">
            <div class="comClass">
              <div class="comTitle">商品类目:</div>
              <el-cascader
                v-model="catgouryS"
                :options="firstcatgoryData"
                :props="{ label: 'label', multiple: true, value: 'id' }"
                clearable
                @change="handleCatgoryChange"
                collapse-tags
                ref="firstcatgory"
                style="260px"
                size="small"
              ></el-cascader>
            </div>
            <div class="comView">
              <div
                class="comItem"
                v-for="(item, index) in selectCategory"
                :key="index"
              >
                <span>{{ item.name }}</span>
                <span
                  class="el-icon-close"
                  @click="handleCategoryClose(index)"
                ></span>
              </div>
            </div>
          </div>
          <!-- 选择品牌 -->
          <div class="com" v-if="ruleForm.shopType == 1">
            <div class="comClass">
              <div class="comTitle">品牌:</div>
              <el-select
                v-model="brandValue"
                filterable
                placeholder="请选择品牌"
                style="width: 140px"
                size="small"
                @change="handleBrandChange">
                <el-option
                  v-for="item in brandData"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="comView">
              <div
                class="comItem"
                v-for="(item, index) in selectBrand"
                :key="index"
              >
                <span>{{ item.name }}</span>
                <span
                  class="el-icon-close"
                  @click="handleBrandClose(index)"
                ></span>
              </div>
            </div>
          </div>
          <!-- 选择商品 -->
          <div v-if="ruleForm.shopType == 3">
            <div style="margin: 10px 0; display: flex">
              <el-button
                type="warning"
                size="small"
                @click="handleSelectGoodsClick(1)"
                >选择商品</el-button
              >
              <el-button
                type="warning"
                size="small"
                @click="handleBatchShopDeleteClick()"
                >批量删除</el-button
              >
            </div>
            <el-table
              :data="shopTable"
              border
              style="width: 100%"
              @selection-change="handleSelectShopChange"
            >
              <el-table-column type="selection" width="55" align="center">
              </el-table-column>
              <el-table-column
                fixed
                prop="param_type_name"
                label="类目"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="name" label="名称" align="center">
              </el-table-column>
              <el-table-column label="规格123445" align="center">
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.sku_value == "" ? "--" : FSkuNames(scope.row)
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="包装单位" align="center">
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.param_packing_way_name == ""
                        ? "--"
                        : scope.row.param_packing_way_name
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    @click="handelDeleteGoodsClick(1, scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 指定条码 -->
          <div v-if="ruleForm.shopType == 4" class="com">
            <div class="comClass">
              <div class="comTitle">芯片编号:</div>
              <el-input
                placeholder="请输入芯片编号"
                v-model="chinNo"
                clearable
                style="width: 160px; margin-right: 20px"
                size="small"
              ></el-input>
              <el-button type="warning" size="small" @click="handelAddPetClick"
                >添加</el-button
              >
            </div>
            <div class="comView">
              <div
                class="comItem"
                v-for="(item, index) in selectPet"
                :key="index"
              >
                <span>{{ item.param_custom_code }}</span>
                <span>{{ item.name }}</span>
                <span
                  class="el-icon-close"
                  @click="handlePetClose(index)"
                ></span>
              </div>
            </div>
          </div>
          <!-- 活体年龄 -->
           <div class="com" v-if="ruleForm.shopType == 5">
            <div class="comClass">
             <div style="margin: 20px 20px; display: flex;">
              <div class="comTitle">活体品种:</div>
              <el-radio-group v-model="pet_type">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">猫</el-radio>
            <el-radio :label="2">狗</el-radio>
          </el-radio-group>
             </div>
          
              <div class="comTitle">活体年龄段:</div>
             <span style="display: flex;align-items: center;">
                  <el-input
                  v-model="pet_age_min"
                    style="width: 80px"
                    placeholder="最低月"
                    size="small"
                  ></el-input>
                  <el-col :span="4" style="text-align: center">月—</el-col>
                  <el-input
                  v-model="pet_age_max"
                    style="width: 80px"
                    placeholder="最高月"
                    size="small"
                  ></el-input>
                  <el-col :span="4" style="text-align: center">月</el-col>
             </span>
            </div>
          </div>
        </div>

        <!-- 添加赠品 -->
        <div
          class="giveView"
          v-if="ruleForm.consume_type == 2 || ruleForm.activity_type == '1'"
        >
          <div class="titleView">
            <div class="line"></div>
            <div class="titleName">添加赠品</div>
          </div>
          <div
            style=" align-items: center; display: flex; margin-top: 10px; height: 32px; flex-wrap: wrap;">
            <div
              style="
                display: flex;
                align-items: center;
                font-size: 14px;
                margin-right: 10px;
              "
            >
              <div style="margin-right: 10px; width: 80px">赠送类型:</div>
              <el-radio-group
                v-model="ruleForm.giveType"
                style="display: flex"
                size="small"
              >
                <el-radio label="1" style="display: flex">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="商品10选3,在列表中添加10件商品,输入自选数量“3”,可领取三件不同商品或三件相同商品"
                    placement="top"
                  >
                    <div>自选<span class="el-icon-question"></span></div>
                  </el-tooltip>
                </el-radio>
                <el-radio label="2" style="display: flex">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="添加商品后，输入该商品指定数量，用户可领取列表中所有商品"
                    placement="top"
                  >
                    <div>指定<span class="el-icon-question"></span></div>
                  </el-tooltip>
                </el-radio>
                <el-radio label="3" style="display: flex">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="充值后，用户可领取赠送列表中，其中一只活体"
                    placement="top"
                  >
                    <div>自选活体<span class="el-icon-question"></span></div>
                  </el-tooltip>
                </el-radio>
              </el-radio-group>
            </div>
            <div style="display: flex; align-items: center; font-size: 14px" v-if="ruleForm.giveType == '1'">
              <div style="margin-right: 10px">自选数量:</div>
              <el-input-number  v-model="optionalNum" label="自选数量"  style="width: 120px" size="small" :min="1"></el-input-number>
            </div>
          </div>
          <div style="margin: 20px 0; display: flex" v-if="ruleForm.giveType != '3'">
            <el-button type="warning" size="small" @click="handleSelectGoodsClick(2)">选择商品</el-button>
            <el-button type="warning" size="small" @click="handleBatchGiveDeleteClick()">批量删除</el-button>
          </div>
          <!-- 添加商品类赠品 -->
          <el-table
            :data="giveTable"
            border
            style="width: 100%"
            @selection-change="handleSelectGiveChange"
            v-if="ruleForm.giveType != '3'"
            size="small"
          >
            <el-table-column
              type="selection"
              width="55"
              align="center"
              :key="1"
            >
            </el-table-column>
            <el-table-column
              fixed
              prop="param_type_name"
              label="类目"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="goods_name" label="名称" align="center">
            </el-table-column>
            <el-table-column label="规格" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.sku_value == "" ? "--" : scope.row }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="包装单位" align="center">
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.packing_way_name == ""
                      ? "--"
                      : scope.row.packing_way_name
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="province"
              label="指定数量"
              align="center"
              :key="8"
              width="142"
              v-if="ruleForm.giveType == 2"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.goods_count"
                  :min="1"
                  style="width: 120px"
                  size="small"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  @click="handelDeleteGoodsClick(2, scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 自选活体芯片编号 -->
          <div v-if="ruleForm.giveType == '3'" class="com">
            <div class="comClass">
              <div class="comTitle">芯片编号:</div>
              <el-input
                placeholder="请输入芯片编号"
                v-model="giveChinNo"
                clearable
                style="width: 160px; margin-right: 20px"
                size="small"
              ></el-input>
              <el-button
                type="warning"
                size="small"
                @click="handelAddGivePetClick"
                >添加</el-button
              >
            </div>
            <el-table :data="selectGivePet" border>
              <el-table-column
                label="昵称"
                prop="inside_name"
                align="center"
              ></el-table-column>
              <el-table-column
                label="品种"
                prop="category_name"
                align="center"
              ></el-table-column>
              <el-table-column
                label="芯片编号"
                prop="eprom_no"
                align="center"
              ></el-table-column>
              <el-table-column
                label="脖圈号"
                prop="inside_no"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    @click="handelDeleteGoodsClick(3, scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="pageRightBtn">
        <el-button @click="handleBackClick" size="small">返回</el-button>
        <el-button
          type="warning"
          @click="handelSubmitClick"
          v-if="routerType != 1"
          size="small"
          >提交活动</el-button
        >
      </div>
    </div>
    <!-- 添加商品弹框 -->
    <div v-if="dialogAddShop_state">
      <dialogAddShop
        @closeOn="dialogAddShop_state = false"
        :addShopState.sync="dialogAddShop_state"
        :selectType.sync="selectType"
        @submit="selectShop"
        :tree.sync="tree"
      ></dialogAddShop>
    </div>
  </div>
</template>

<script>
import {
  getBrand,
  firstcatgory,
  addActive,
  epromno,
  updateActive,
} from "@/api/purchaseApi.js";
import dialogAddShop from "../../components/dialog_addShop.vue";
import { stringify } from "querystring";
export default {
  components: {
    dialogAddShop,
  },
  data() {
    return {
		disabled:false,
      routerType: this.$route.query.type, // 1查看 2编辑
      activitInfo: this.$route.query.activitInfo, //跳转详情
      fixedHeight: "",
      ruleForm: {
        activity_type: "2", //活动类型  1充值 2消费
        name: "", //活动名称
        auto_matching: "0", //活动权重
        activity_user: "0", //用户类型 0全部 1普通会员 2充值会员 3散客 4员工

        vipCardUser: null, //会员等级
        new_member: "2", //是否新人专享
        hs_master: "0", //是否花生宠物主
        pet_buy_item:'0',
        medical_param: "0", //医疗选项
        activity_model: "0", //活动地点
        shop_id: [
          "5e9412e0b2bfbc089daerr12",
          "5e9412e0b2bfbc089daerr13",
          "5e9412e0b2bfbc089daerr16",
          "5e9412e0b2bfbc089daerr15",
          "5e9412e0b2bfbc089daerr17",
          "5e9412e0b2bfbc089daerr18",
        ], //门店id集合
        activity_time: "", //活动时间集合
        remark: "", //活动说明
        consume_type: "1", //优惠类型  1满减 2满赠 3折扣 4立减 5特价
       
        pay_type: ["7", "-1"], //支付方式  7余额  -1非余额   11第三方
        staff_type: ["1", "2"], //员工身份
        shopType: "0", //商品类型    0全部商品 1品牌 2商品类目 3指定商品 4指定活体
        giveType: "1", //赠品类型 1自选 2指定
        use_count: 0, //参与次数
        //充值类型
        rechangePrice: "", //充值金额
        rechangeGive: "0", //赠送金额
        //消费类型
        fullReductionCon: "", //满减条件
        fulleductionValue: "", //满减值
        fullGiveNum: "", //满赠数量
        fullGiveMoney: "", //满赠金额
        discountValue: "", //折扣
        minusValue: "", //立减
        specialValue: "", //特价
      },
      pet_age_min:null,//最小年龄
      pet_age_max:null, //最大年龄
      pet_type:"0",//0不限 1猫 2狗
      pet_age_info:{
      
      },
      reductionTabs: 1, //满赠切换
      brandData: [], //品牌数据
      brandValue: "", //选中品牌值
      selectBrand: [], //选中品牌
      firstcatgoryData: [], //获取分类列表
      selectCategory: [], //选中类目
      catgouryS: [], //回显
      shopTable: [], //商品表格
      giveTable: [], //赠品表格
      dialogAddShop_state: false, //新增商品弹框状态
      selectType: 1, //选择商品或者赠品状态
      optionalNum: 1, //自选数量
      chinNo: "", //芯片编号
      tree: [], //添加商品弹框 上传显示类
      selectPet: [], //选中芯片编号
      selectShopTable: [], //选中商品表格
      selectGiveTable: [], //选中赠品表格
      giveChinNo: "", //赠品芯片编号
      selectGivePet: [], //选中赠品芯片编号
    };
  },
  mounted() {
    this.fixedHeight = document.documentElement.clientHeight - 86;
    //详情跳转回显数据
    if (this.activitInfo != undefined) {
      console.log("详情", JSON.parse(this.activitInfo));
      let info = JSON.parse(this.activitInfo);
      let ruleForm = this.ruleForm;
      // ---------------公共数据回显
      ruleForm.activity_type = info.activity_type + ""; //活动类型
      ruleForm.name = info.name; //活动名称
      ruleForm.auto_matching = info.auto_matching + ""; //活动权重
      ruleForm.activity_user = info.activity_user + ""; //用户类型
      ruleForm.new_member = info.new_member + ""; //是否新人专享
      ruleForm.hs_master = info.hs_master + ""; //是否新人专享
      ruleForm.pet_buy_item = info.pet_buy_item + ""; //购宠保障
      ruleForm.medical_param = info.medical_param + ""; //医疗选项
      ruleForm.activity_model = info.activity_model + ""; //活动地点

      //员工身份
      if (info.activity_user == 4) {
        ruleForm.staff_type = info.staff_type;
      } else {
        ruleForm.staff_type = ["1", "2"];
      }
      //所选门店
      let shop_id = [];
      for (let i = 0; i < info.company_Info.length; i++) {
        shop_id.push(info.company_Info[i].shop_id);
      }
      ruleForm.shop_id = shop_id;

      ruleForm.activity_time = [
        new Date(info.start_time * 1000),
        new Date(info.exprice_time * 1000),
      ]; //活动时间
      ruleForm.remark = info.remark; //活动说明
      //支付方式
      if (info.pay_type == "") {
        ruleForm.pay_type = [];
      } else {
        ruleForm.pay_type = info.pay_type.split(",");
      }

      // ------------------充值规则回显
      if (info.activity_type == 1) {
        ruleForm.rechangePrice = info.activity_recharge.price + "";
      }

      // ------------------消费规则回显
      if (info.activity_type == 2) {
        ruleForm.use_count = info.use_count; //参与次数
        ruleForm.consume_type = info.consume_item.consume_type + ""; //消费活动类型
        //满减
        if (info.consume_item.consume_type == 1) {
          ruleForm.fullReductionCon =
            info.consume_item.full_reduction.full_reduction_conditions; //满减条件
          ruleForm.fulleductionValue =
            info.consume_item.full_reduction.full_reduction_value; //满减值
        }
        //满赠
        if (info.consume_item.consume_type == 2) {
          this.reductionTabs = info.consume_item.full_give.full_give_type; //满赠类型
          if (info.consume_item.full_give.full_give_type == 1) {
            ruleForm.fullGiveMoney =
              info.consume_item.full_give.full_give_conditions; //满赠金额
          } else {
            ruleForm.fullGiveNum =
              info.consume_item.full_give.full_give_conditions; //满赠数量
          }
        }
        //折扣
        if (info.consume_item.consume_type == 3) {
          ruleForm.discountValue =
            info.consume_item.other_info.other_info_value + "";
        }
        //立减
        if (info.consume_item.consume_type == 4) {
          ruleForm.minusValue =
            info.consume_item.other_info.other_info_value + "";
        }
        //特价
        if (info.consume_item.consume_type == 5) {
          ruleForm.specialValue =
            info.consume_item.other_info.other_info_value + "";
        }
      }
      // ------------------产品回显
      if (info.activity_type == 2) {
        ruleForm.shopType = info.consume_item.type + ""; //添加产品类型
        //品牌
        if (info.consume_item.type == 1) {
          this.selectBrand = info.consume_item.param;
        }
        //类目
        if (info.consume_item.type == 2) {
          console.log(info.consume_item.param);
          this.catgouryS = JSON.parse(info.consume_item.data_str);
          this.selectCategory = info.consume_item.param;
        }
        //指定商品
        if (info.consume_item.type == 3) {
          this.shopTable = info.consume_item.param;
        }
        //指定活体
        if (info.consume_item.type == 4) {
          this.selectPet = info.consume_item.param;
        }
        //活体年龄
        if (info.consume_item.type == 5) {
          console.log(info.consume_item,"pet_age_infoinfo.consume_item");
          // this.pet_age_info = info.consume_item.pet_age_info;
          this.pet_type = info.consume_item.pet_age_info.pet_type;
          this.pet_age_min = info.consume_item.pet_age_info.pet_age_min;
          this.pet_age_max = info.consume_item.pet_age_info.pet_age_max;

        }
      }

      // ------------------赠品回显
      if (info.activity_type == 1 || info.consume_item.consume_type == 2) {
        ruleForm.giveType = info.give_goods.give_type + ""; //赠送类型
        this.optionalNum = info.give_goods.give_count + ""; //自选数量
        this.giveTable = info.give_goods.give_list; //赠品列表
        this.selectGivePet = info.give_goods.give_living_list; //赠送活体列表
      }
    }
    this.getBrandList();
    this.getFirstcatgory();
  },
  methods: {
    changeType(arr) {
    //   console.log("值的变化", arr);
	  if(arr.indexOf('11') > -1){//则包含该元素
		this.disabled=true;
		this.ruleForm.pay_type=['11'];
	  }else{
		this.disabled=false;
		this.ruleForm.pay_type=arr;
	  }
    },
    //添加自选活体
    handelAddGivePetClick() {
      if (this.giveChinNo == "") {
        this.$message({
          type: "error",
          message: "芯片编号不能为空",
        });
        return;
      }
      if (this.selectGivePet.length != 0) {
        for (let i = 0; i < this.selectGivePet.length; i++) {
          if (this.giveChinNo == this.selectGivePet[i].eprom_no) {
            this.$message({
              type: "error",
              message: "重复添加芯片编号",
            });
            return;
          }
        }
      }
      let params = {
        epromno: this.giveChinNo,
      };
      epromno(params).then((res) => {
        console.log(res);
        if (res.code == 0) {
          console.log("活体信息", res);
          if (res.data.pet_status.value == "1") {
            let obj = {
              eprom_no: res.data.eprom_no,
              pet_id: res.data.petId,
              inside_no: res.data.inside_no,
              inside_name: res.data.inside_name,
              category_name: res.data.color + res.data.breed_info.name,
            };
            this.selectGivePet.push(obj);
          } else {
            this.$message({
              type: "error",
              message: res.data.pet_status.title,
            });
          }
        }
      });
    },
    //赠品列表批量删除
    handleBatchGiveDeleteClick() {
      if (this.selectGiveTable.length == 0) {
        this.$message({
          type: "error",
          message: "请选中产品",
        });
        return;
      }
      for (let i = 0; i < this.selectGiveTable.length; i++) {
        for (let j = 0; j < this.giveTable.length; j++) {
          if (this.selectGiveTable[i].param_type_id == 0) {
            //删除商品
            if (
              this.selectGiveTable[i].goods_id == this.giveTable[j].goods_id &&
              this.selectGiveTable[i].skus == this.giveTable[j].skus
            ) {
              this.giveTable.splice(j, 1);
            }
          } else {
            if (
              this.selectGiveTable[i].goods_id == this.giveTable[j].goods_id
            ) {
              this.giveTable.splice(j, 1);
            }
          }
        }
      }
    },
    //获取选中赠品
    handleSelectGiveChange(val) {
      this.selectGiveTable = val;
    },
    //获取选中商品
    handleSelectShopChange(val) {
      this.selectShopTable = val;
    },
    //提交活动
    handelSubmitClick() {
      console.log("提交活动", this.ruleForm);
      // console.log('数据',this.$store.state.userInfo)
      // console.log('赠送商品列表',this.giveTable)
      console.log("添加商品列表", this.shopTable);
      // console.log('选中品牌',this.selectBrand)
      // console.log('选中类目',this.selectCategory)
      let ruleForm = this.ruleForm;
      // -----------------------验证
      if (ruleForm.name == "") {
        this.$message({
          type: "error",
          message: "请输入活动名称",
        });
        return;
      }
      if (ruleForm.name.length < 4 || ruleForm.name.length > 32) {
        this.$message({
          type: "error",
          message: "活动名称字数为4-32字",
        });
        return;
      }
      if (ruleForm.shop_id.length == 0) {
        this.$message({
          type: "error",
          message: "请选择适用门店",
        });
        return;
      }
      if (ruleForm.activity_time == "") {
        this.$message({
          type: "error",
          message: "请选择活动时间",
        });
        return;
      }
      if (ruleForm.remark == "") {
        this.$message({
          type: "error",
          message: "请填写活动说明",
        });
        return;
      }
      if (ruleForm.remark.length < 4 || ruleForm.remark.length > 64) {
        this.$message({
          type: "error",
          message: "活动说明字数为4-64字",
        });
        return;
      }
      //充值类型
      if (ruleForm.activity_type == "1") {
        if (ruleForm.rechangePrice == "") {
          this.$message({
            type: "error",
            message: "充值：请输入充值金额",
          });
          return;
        }
      } else if (ruleForm.activity_type == "2") {
        //消费类型
        //满减限制
        if (ruleForm.consume_type == "1") {
          if (ruleForm.fullReductionCon == "") {
            this.$message({
              type: "error",
              message: "满减：请输入满减条件",
            });
            return;
          }
          if (ruleForm.fulleductionValue == "") {
            this.$message({
              type: "error",
              message: "满减：请输入满减值",
            });
            return;
          }
        }
        // 满赠
        if (ruleForm.consume_type == "2") {
          if (this.reductionTabs == 1) {
            if (ruleForm.fullGiveMoney == "") {
              this.$message({
                type: "error",
                message: "满赠：请输入满赠金额",
              });
              return;
            }
          }
          if (this.reductionTabs == 2) {
            if (ruleForm.fullGiveNum == "") {
              this.$message({
                type: "error",
                message: "满赠：请输入满赠数量",
              });
              return;
            }
          }
        }
        //折扣
        if (ruleForm.consume_type == "3") {
          if (ruleForm.discountValue == "") {
            this.$message({
              type: "error",
              message: "折扣：请输入折扣",
            });
            return;
          }
        }
        //立减
        if (ruleForm.consume_type == "4") {
          if (ruleForm.minusValue == "") {
            this.$message({
              type: "error",
              message: "立减：请输入立减金额",
            });
            return;
          }
        }
        //特价
        if (ruleForm.consume_type == "5") {
          if (ruleForm.specialValue == "") {
            this.$message({
              type: "error",
              message: "特价：请输入特价金额",
            });
            return;
          }
        }
      }

      // 产品
      if (ruleForm.activity_type == "2") {
        //品牌
        if (ruleForm.shopType == "1") {
          if (this.selectBrand.length == 0) {
            this.$message({
              type: "error",
              message: "请选择品牌",
            });
            return;
          }
        }
        //商品类目
        if (ruleForm.shopType == "2") {
          if (this.selectCategory.length == 0) {
            this.$message({
              type: "error",
              message: "请选择商品类目",
            });
            return;
          }
        }
        //指定商品
        if (ruleForm.shopType == "3") {
          if (this.shopTable.length == 0) {
            this.$message({
              type: "error",
              message: "请选择商品",
            });
            return;
          }
        }
        //指定活体
        if (ruleForm.shopType == "4") {
          if (this.selectPet.length == 0) {
            this.$message({
              type: "error",
              message: "请添加芯片编号",
            });
            return;
          }
        }
         //指定活体
        //  if (ruleForm.shopType == "5") {
        //   if (this.pet_age_info) {
        //     this.$message({
        //       type: "error",
        //       message: "请添加活体年龄",
        //     });
        //     return;
        //   }
        // }
      }
      //赠品
      if (ruleForm.consume_type == "2") {
        if (this.giveTable.length == 0) {
          this.$message({
            type: "error",
            message: "请选择赠品",
          });
          return;
        }
      }
      // -----------------------公共参数
      let params = {
        name: ruleForm.name, //活动名称
        start_time: ruleForm.activity_time[0].getTime() / 1000, //开始时间
        exprice_time: ruleForm.activity_time[1].getTime() / 1000, //结束时间
        activity_model: Number(ruleForm.activity_model), //活动地点  0全部 1线上 2线下
        activity_user: Number(ruleForm.activity_user), //用户类型 0全部 1普通会员 2充值会员 3散客 4员工
        pay_type: this.arrTurnStr(ruleForm.pay_type), //付款方式
        new_member: ruleForm.new_member, //是否新人专享
        hs_master: ruleForm.hs_master, //是否新人专享
        pet_buy_item: ruleForm.pet_buy_item, //购宠保障
        activity_type: ruleForm.activity_type, //活动类型 1充值 2消费
        remark: ruleForm.remark, //备注
        auto_matching: Number(ruleForm.auto_matching), //活动权重
      };
      //判断员工显示
      if (ruleForm.activity_user == "4") {
        params.staff_type = this.arrTurnStr(ruleForm.staff_type);
      } else {
        params.staff_type = "";
      }
      //指定公司和门店
      let company_Info = [];
      for (let i = 0; i < ruleForm.shop_id.length; i++) {
        company_Info[i] = {
          company_id: this.$store.state.userInfo.companyId, //公司id
          company_name: this.$store.state.userInfo.companyName, //公司名称
          shop_id: ruleForm.shop_id[i], //门店id
          shop_name: this.getShopNameData(ruleForm.shop_id[i]), //门店名称
        };
      }
      params.company_Info = company_Info;

      // ----------------------私有参数

      //----充值
      if (ruleForm.activity_type == "1") {
        params.activity_recharge = {
          price: ruleForm.rechangePrice, //充值金额
          give: ruleForm.rechangeGive, //赠送金额
        };
        params.consume_item == null; //消费类型null
        params.give_goods = {
          //赠品
          give_type: Number(ruleForm.giveType), //赠送类型 1自选 2指定 3自选活体
        };
        if (ruleForm.giveType == "1") {
          params.give_goods.give_count = this.optionalNum; //自选数量
        } else if (ruleForm.giveType == "3") {
          console.log("自选活体");
          params.give_goods.give_count = 1;
        }
        params.give_goods.give_list = this.giveTable;
        params.give_goods.give_living_list = this.selectGivePet;
      } else {
        //----消费
        params.use_count = ruleForm.use_count; //参与次数
        params.activity_recharge = null; //充值类型为null
        params.consume_item = {
          consume_type: Number(ruleForm.consume_type), //消费活动类型 1满减 2 满赠 3.折扣 4.立减 5 特价
          type: Number(ruleForm.shopType), //添加产品类型 -1无 0全部商品 1品牌 2商品类目 3指定商品 4指定活体
        };
        //添加商品类获取数据
        if (ruleForm.shopType == "0") {
          //全部商品
          params.consume_item.param = null;
        } else if (ruleForm.shopType == "1") {
          //品牌
          params.consume_item.param = this.selectBrand;
        } else if (ruleForm.shopType == "2") {
          //商品类目
          params.consume_item.param = this.selectCategory;
          params.consume_item.data_str = JSON.stringify(this.catgouryS);
        } else if (ruleForm.shopType == "3") {
          //指定商品
          params.consume_item.param = this.shopTable;
        } else if (ruleForm.shopType == "4") {
          //指定活体
          params.consume_item.param = this.selectPet;
        }else if (ruleForm.shopType == "5") {
         
          //指定活体
          params.consume_item.pet_age_info = {
            pet_age_min:this.pet_age_min,
            pet_age_max:this.pet_age_max,
            pet_type:this.pet_type
          };
          
          // params.consume_item.pet_age_info.pet_age_min = this.pet_age_min;
          // params.consume_item.pet_age_info.pet_age_max = this.pet_age_max;
        }

        //3折扣 4立减 5特价
        if (ruleForm.consume_type == "3") {
          params.consume_item.other_info = {
            other_info_value: Number(ruleForm.discountValue),
          };
          params.consume_item.full_reduction = null;
          params.consume_item.full_give = null;
        } else if (ruleForm.consume_type == "4") {
          params.consume_item.other_info = {
            other_info_value: Number(ruleForm.minusValue),
          };
          params.consume_item.full_reduction = null;
          params.consume_item.full_give = null;
        } else if (ruleForm.consume_type == "5") {
          params.consume_item.other_info = {
            other_info_value: Number(ruleForm.specialValue),
          };
          params.consume_item.full_reduction = null;
          params.consume_item.full_give = null;
        } else {
          params.consume_item.other_info = null;
        }

        //1满减
        if (ruleForm.consume_type == "1") {
          params.consume_item.full_reduction = {
            full_reduction_type: 1,
            full_reduction_value: Number(ruleForm.fulleductionValue), //满减值
            full_reduction_conditions: Number(ruleForm.fullReductionCon), //满减条件
          };
          params.consume_item.full_give = null;
        }
        //2满赠
        if (ruleForm.consume_type == "2") {
          params.consume_item.full_reduction = null;
          params.consume_item.full_give = {
            full_give_type: this.reductionTabs,
          };
          if (this.reductionTabs == 1) {
            params.consume_item.full_give.full_give_conditions = Number(
              ruleForm.fullGiveMoney
            ); //满赠金额
          } else {
            params.consume_item.full_give.full_give_conditions = Number(
              ruleForm.fullGiveNum
            ); //满赠数量
          }
          params.give_goods = {
            //赠品
            give_type: Number(ruleForm.giveType), //赠送类型 1自选 2指定
          };
          if (ruleForm.giveType == "1") {
            params.give_goods.give_count = this.optionalNum; //自选数量
          }
          params.give_goods.give_list = this.giveTable;
        }
      }
      if (this.routerType != 2) {
        console.log("创建params", params);
        addActive(params).then((res) => {
          if (res.code == 0) {
            console.log("返回", res);
            this.$message({
              type: "success",
              message: "创建成功",
            });
            this.$router.push({ path: "huodongList" });
          }
        });
      } else {
        let info = JSON.parse(this.activitInfo);
        params.id = info._id;

        updateActive(params).then((res) => {
          if (res.code == 0) {
            console.log("返回", res);
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.$router.push({ path: "huodongList" });
          }
        });
      }
      console.log("参数vparams", params);
    },
    //商品列表批量删除
    handleBatchShopDeleteClick() {
      if (this.selectShopTable.length == 0) {
        this.$message({
          type: "error",
          message: "请选中产品",
        });
        return;
      }
      for (let i = 0; i < this.selectShopTable.length; i++) {
        for (let j = 0; j < this.shopTable.length; j++) {
          if (this.selectShopTable[i].param_type_id == 0) {
            //删除商品
            if (
              this.selectShopTable[i].goods_id == this.shopTable[j].goods_id &&
              this.selectShopTable[i].skus == this.shopTable[j].skus
            ) {
              this.shopTable.splice(j, 1);
            }
          } else {
            if (
              this.selectShopTable[i].goods_id == this.shopTable[j].goods_id
            ) {
              this.shopTable.splice(j, 1);
            }
          } 
        }
      }
    },
    //切换添加产品 初始化
    handelShopTypeClick() {
      this.selectBrand = [];
      this.selectCategory = [];
      this.shopTable = [];
      this.selectPet = [];
      this.chinNo = "";
      this.optionalNum = 0;
      this.brandValue = "";
    },
    //切换充值消费 初始化
    handleActivityTypeClick() {
      if (this.ruleForm.activity_type == "1") {
        this.ruleForm.name = "";
        this.ruleForm.remark = "";
        this.ruleForm.activity_time = "";
        this.ruleForm.fullReductionCon = ""; //满减条件
        this.ruleForm.fulleductionValue = ""; //满减值
        this.ruleForm.fullGiveNum = ""; //满赠数量
        this.ruleForm.fullGiveMoney = ""; //满赠金额
        this.ruleForm.discountValue = ""; //折扣
        this.ruleForm.minusValue = ""; //立减
        this.ruleForm.specialValue = ""; //特价
        this.selectBrand = [];
        this.selectCategory = [];
        this.shopTable = [];
        this.selectPet = [];
        this.chinNo = "";
        this.optionalNum = 0;
        this.brandValue = "";
        this.giveTable = [];
      } else {
        this.ruleForm.name = "";
        this.ruleForm.remark = "";
        this.ruleForm.activity_time = "";
        this.ruleForm.rechangePrice = ""; //充值金额
        this.ruleForm.rechangeGive = "0"; //赠送金额
        this.giveTable = [];
        this.optionalNum = 0;
      }
    },
    //切换活动类型 初始化
    handelConsumeTypeClick() {
      this.ruleForm.fullReductionCon = ""; //满减条件
      this.ruleForm.fulleductionValue = ""; //满减值
      this.ruleForm.fullGiveNum = ""; //满赠数量
      this.ruleForm.fullGiveMoney = ""; //满赠金额
      this.ruleForm.discountValue = ""; //折扣
      this.ruleForm.minusValue = ""; //立减
      this.ruleForm.specialValue = ""; //特价
    },
    //返回
    handleBackClick() {
      this.$confirm("是否退出当前页面？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ path: "huodongList" });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //删除选中芯片编号
    handlePetClose(index) {
      this.selectPet.splice(index, 1);
    },
    //添加指定活体
    handelAddPetClick() {
      console.log("活体列表", this.petData);
      let params = {
        epromno: this.chinNo,
      };
      epromno(params).then((res) => {
        console.log(res);
        if (res.code == 0) {
          console.log("活体信息", res);
          let obj = {
            param_type_id: "5",
            param_type_name: "活体",
            id: "",
            name: res.data.inside_name,
            param_sku_id: "",
            param_sku_name: "",
            param_packing_way_id: "",
            param_packing_way_name: "",
            param_custom_code: this.chinNo,
          };
          this.selectPet.push(obj);
        }
      });
    },
    //获取门店名称
    getShopNameData(id) {
      let shopName = "";
      switch (id) {
        case "5e9412e0b2bfbc089daerr12":
          shopName = "花生宠物4S店(金水区店)";
          break;
        case "5e9412e0b2bfbc089daerr14":
          shopName = "花生宠物(指挥中心店)";
          break;
        case "5e9412e0b2bfbc089daerr16":
          shopName = "花生宠物4S店(万达店)";
          break;
        case "5e9412e0b2bfbc089daerr17":
          shopName = "花生宠物(线上旗舰店)";
      }
      return shopName;
    },
    //数组转字符串
    arrTurnStr(arr) {
      let str = "";
      for (let i = 0; i < arr.length; i++) {
        str += arr[i] + ",";
      }
      str =
        str.substring(str.length - 1) == ","
          ? str.substring(0, str.length - 1)
          : str;
      return str;
    },
    //删除商品
    handelDeleteGoodsClick(type, index) {
      console.log(type, index);
      if (type == 1) {
        //删除商品
        this.shopTable.splice(index, 1);
        this.$message({
          type: "error",
          message: "已删除",
        });
      } else if (type == 2) {
        //删除赠品
        this.giveTable.splice(index, 1);
        this.$message({
          type: "error",
          message: "已删除",
        });
      } else if (type == 3) {
        //删除赠品
        this.selectGivePet.splice(index, 1);
        this.$message({
          type: "error",
          message: "已删除",
        });
      }
    },
    //已选中商品
    selectShop(val) {
      console.log("已选中商品11111", val);
      let shopObj = {
        param_type_id:val.goodsType+ "",
      };
      console.log("已选中商品", shopObj);
      //添加商品
      if (this.selectType == 1) {
        if (val.goodsType == 0) {
          //商品类目
          shopObj.param_type_name = "商品"; //类型名字
          shopObj.id = val.goodsItem.goodsId; //商品id
          shopObj.name = val.goodsItem.title; //商品名字
          shopObj.param_sku_id = val.skuItem._id; //规格id
          shopObj.param_sku_name = val.skuItem.skus_name; //规格
          shopObj.param_packing_way_id = val.wayItem.packing_way_id; //包装方式id
          shopObj.param_packing_way_name = val.wayItem.packing_way_name; //包装方式名称
        } else if (val.goodsType == 6) {
          //虚拟卡
          shopObj.param_type_name = "卡"; //类型名字
          shopObj.id = val.goodsItem.virtualId; //商品id
          shopObj.name = val.goodsItem.title; //商品名字
          shopObj.param_sku_id = val.skuItem.detail_id; //规格id
          shopObj.param_sku_name = val.skuItem.service_objectName; //规格
          shopObj.param_packing_way_id = ""; //包装方式id
          shopObj.param_packing_way_name = ""; //包装方式名称
        } else if (val.goodsType == 5) {
          //活体
          shopObj.param_type_name = "活体"; //类型名字
          shopObj.id = val.goodsItem.petCategoryId; //商品id
          shopObj.name = val.goodsItem.title; //商品名字
          shopObj.param_sku_id = val.skuItem._id; //规格id
          shopObj.param_sku_name = val.skuItem.stars + "星"; //规格
          shopObj.param_packing_way_id = ""; //包装方式id
          shopObj.param_packing_way_name = ""; //包装方式名称
        } else if (val.goodsType == 1) {
          //医疗
          shopObj.param_type_name = "医疗"; //类型名字
          shopObj.id = val.goodsItem.medical_id; //商品id
          shopObj.name = val.goodsItem.title; //商品名字
          shopObj.param_sku_id = ""; //规格id
          shopObj.param_sku_name = ""; //规格
          shopObj.param_packing_way_id = ""; //包装方式id
          shopObj.param_packing_way_name = ""; //包装方式名称
        } else if (val.goodsType == 2) {
          //生活服务
          shopObj.param_type_name = "生活服务"; //类型名字
          shopObj.id = val.goodsItem.serviceId; //商品id
          shopObj.name = val.goodsItem.title; //商品名字
          shopObj.param_sku_id = val.skuItem.service_objectId; //规格id
          shopObj.param_sku_name =
            (val.skuItem.extend_attr == null ? "" : val.skuItem.extend_attr) +
            val.skuItem.service_objectName; //规格
          shopObj.param_packing_way_id = ""; //包装方式id
          shopObj.param_packing_way_name = ""; //包装方式名称
        } else if (val.goodsType == 4) {
          //医疗服务
          shopObj.param_type_name = "医疗服务"; //类型名字
          shopObj.id = val.goodsItem.serviceId; //商品id
          shopObj.name = val.goodsItem.title; //商品名字
          shopObj.param_sku_id = val.skuItem.service_objectId; //规格id
          shopObj.param_sku_name =
            val.skuItem.extend_attr + val.skuItem.service_objectName; //规格
          shopObj.param_packing_way_id = ""; //包装方式id
          shopObj.param_packing_way_name = ""; //包装方式名称
        } else if (val.goodsType == 8) {
          //医疗服务
          shopObj.param_type_name = "套餐"; //类型名字
          shopObj.id = val.goodsItem.groupId; //商品id
          shopObj.name = val.goodsItem.title; //商品名字
          shopObj.param_sku_id = ""; //规格id
          shopObj.param_sku_name = ""; //规格
          shopObj.param_packing_way_id = ""; //包装方式id
          shopObj.param_packing_way_name = ""; //包装方式名称
        }
        shopObj.param_custom_code = ""; //芯片编号
        for (let i = 0; i < this.shopTable.length; i++) {
          if (shopObj.param_type_id == 0) {
            if (
              shopObj.id == this.shopTable[i].id &&
              shopObj.param_sku_id == this.shopTable[i].param_sku_id &&
              shopObj.param_packing_way_id ==
                this.shopTable[i].param_packing_way_id
            ) {
              this.$message({
                type: "error",
                message: "已重复添加",
              });
              return;
            }
          } else {
            if (
              shopObj.id == this.shopTable[i].id &&
              shopObj.param_sku_id == this.shopTable[i].param_sku_id
            ) {
              this.$message({
                type: "error",
                message: "已重复添加",
              });
              return;
            }
          }
        }
        this.shopTable.push(shopObj);
        console.log("商品列表", this.shopTable);
        this.$message({
          type: "success",
          message: "已添加",
        });
      } else if (this.selectType == 2) {
        if (val.goodsType == 0) {
          //商品类目
          shopObj.param_type_name = "商品"; //类型名字
          shopObj.goods_id = val.goodsItem.goodsId; //商品id
          shopObj.goods_name = val.goodsItem.title; //商品名字
          shopObj.skus = val.skuItem._id; //规格id
          shopObj.sku_value = val.skuItem.skus_name; //规格
          shopObj.packing_way_id = val.wayItem.packing_way_id; //包装方式id
          shopObj.packing_way_name = val.wayItem.packing_way_name; //包装方式名称
        } else if (val.goodsType == 6) {
          //虚拟卡
          shopObj.param_type_name = "卡"; //类型名字
          shopObj.goods_id = val.goodsItem.virtualId; //商品id
          shopObj.goods_name = val.goodsItem.title; //商品名字
          shopObj.skus = val.skuItem.detail_id; //规格id
          shopObj.sku_value = val.skuItem.service_objectName; //规格
          shopObj.packing_way_id = ""; //包装方式id
          shopObj.packing_way_name = ""; //包装方式名称
        } else if (val.goodsType == 5) {
          //活体
          shopObj.param_type_name = "活体"; //类型名字
          shopObj.goods_id = val.goodsItem.petCategoryId; //商品id
          shopObj.goods_name = val.goodsItem.title; //商品名字
          shopObj.skus = val.skuItem._id; //规格id
          shopObj.sku_value = val.skuItem.stars + "星"; //规格
          shopObj.packing_way_id = ""; //包装方式id
          shopObj.packing_way_name = ""; //包装方式名称
        } else if (val.goodsType == 1) {
          //医疗
          shopObj.param_type_name = "医疗"; //类型名字
          shopObj.goods_id = val.goodsItem.medical_id; //商品id
          shopObj.goods_name = val.goodsItem.title; //商品名字
          shopObj.skus = ""; //规格id
          shopObj.sku_value = ""; //规格
          shopObj.packing_way_id = ""; //包装方式id
          shopObj.packing_way_name = ""; //包装方式名称
        } else if (val.goodsType == 2) {
          //医疗
          shopObj.param_type_name = "生活服务"; //类型名字
          shopObj.goods_id = val.goodsItem.serviceId; //商品id
          shopObj.goods_name = val.goodsItem.title; //商品名字
          shopObj.skus = val.skuItem.service_objectId; //规格id
          shopObj.sku_value = val.skuItem.service_objectName; //规格
          shopObj.packing_way_id = ""; //包装方式id
          shopObj.packing_way_name = ""; //包装方式名称
        } else if (val.goodsType == 4) {
          //医疗服务
          shopObj.param_type_name = "医疗服务"; //类型名字
          shopObj.goods_id = val.goodsItem.serviceId; //商品id
          shopObj.goods_name = val.goodsItem.title; //商品名字
          shopObj.skus = val.skuItem.service_objectId; //规格id
          shopObj.sku_value = val.skuItem.service_objectName; //规格
          shopObj.packing_way_id = ""; //包装方式id
          shopObj.packing_way_name = ""; //包装方式名称
        } else if (val.goodsType == 8) {
          //医疗服务
          shopObj.param_type_name = "套餐"; //类型名字
          shopObj.goods_id = val.goodsItem.groupId; //商品id
          shopObj.goods_name = val.goodsItem.title; //商品名字
          shopObj.skus = ""; //规格id
          shopObj.sku_value = ""; //规格
          shopObj.packing_way_id = ""; //包装方式id
          shopObj.packing_way_name = ""; //包装方式名称
        }
        //添加赠品
        shopObj.goods_count = 0; //指定数量||服务次数
        for (let i = 0; i < this.giveTable.length; i++) {
          if (shopObj.param_type_id == 0) {
            if (
              shopObj.goods_id == this.giveTable[i].goods_id &&
              shopObj.skus == this.giveTable[i].skus &&
              shopObj.packing_way_id == this.giveTable[i].packing_way_id
            ) {
              this.$message({
                type: "error",
                message: "已重复添加",
              });
              return;
            }
          } else {
            if (
              shopObj.goods_id == this.giveTable[i].goods_id &&
              shopObj.skus == this.giveTable[i].skus
            ) {
              this.$message({
                type: "error",
                message: "已重复添加",
              });
              return;
            }
          }
        }
        this.giveTable.push(shopObj);
        console.log("赠品列表", this.giveTable);
        this.$message({
          type: "success",
          message: "已添加",
        });
      }
    },
    //选择商品
    handleSelectGoodsClick(type) {
      if (type == 1) {
        console.log("添加产品");
        this.dialogAddShop_state = true;
        this.selectType = type;
        this.tree = [
          {
            //显示所需要类目
            id: "602f1e89c904d9db7ccf3c03", //商品
          },
          {
            id: "602f1e88c904d9db7ccf3bec", //医疗
          },
          {
            id: "60210f916e6d952a3929f0eb", //虚拟
            children: [
              {
                id: "60210f916e6d952a3929f0ec",
              },
            ],
          },
          {
            id: "603f7255664b790a9c7d4f60", //活体
          },
          {
            id: "601d11cda93f55b5cf3ae2d1", //生活服务
          },
          {
            id: "601d11cfa93f55b5cf3ae2eb", //医疗服务
          },
          {
            id: "604323824335a2f958dc740a", //套餐
            children: [
              {
                id: "604323834335a2f958dc7412",
              },
            ],
          },
        ];
      } else if (type == 2) {
        console.log("添加赠品");
        this.dialogAddShop_state = true;
        this.selectType = type;
        this.tree = [
          {
            //显示所需要类目
            id: "602f1e89c904d9db7ccf3c03",
          },
          {
            id: "60210f916e6d952a3929f0eb",
            children: [
              {
                id: "60210f916e6d952a3929f0ec",
              },
            ],
          },
          {
            id: "603f7255664b790a9c7d4f60",
          },
        ];
        // ,{
        // 	id: "602f1e88c904d9db7ccf3bec"
        // }
      }
    },
    //格式化规格
    FSkuNames(str) {
      // console.log(str)
      if (str.param_type_id == 0) {
        let s = "";
        let arr = str.param_sku_name.split(",");
        for (let i = 0; i < arr.length; i++) {
          s += arr[i].split(":")[1] + "，";
        }
        return s.substr(0, s.length - 1);
      } else {
        return str.param_sku_name;
      }
    },
    //删除选中品牌
    handleBrandClose(index) {
      this.selectBrand.splice(index, 1);
    },
    //获取选中品牌
    handleBrandChange(value) {
      // console.log(this.brandData)
      if (this.selectBrand.length > 0) {
        for (let j = 0; j < this.selectBrand.length; j++) {
          if (value == this.selectBrand[j]._id) {
            this.$message({
              type: "warning",
              message: "已重复添加",
            });
            this.brandValue = "";
            return;
          }
        }
      }
      for (let i = 0; i < this.brandData.length; i++) {
        if (value == this.brandData[i]._id) {
          this.selectBrand.push({
            param_type_id: "",
            param_type_name: "",
            id: this.brandData[i]._id,
            name: this.brandData[i].name,
            param_sku_id: "",
            param_sku_name: "",
            param_packing_way_id: "",
            param_packing_way_name: "",
            param_custom_code: "",
          });
        }
      }
    },
    //删除选中商品类目
    handleCategoryClose(index) {
      this.selectCategory.splice(index, 1);
    },
    //获取选中商品类目
    handleCatgoryChange() {
      console.log("类目", this.catgouryS);
      let nodesObj = this.$refs["firstcatgory"].getCheckedNodes(true);
      console.log(nodesObj,"nodesObj");
      let categroyInfo = nodesObj.map((item) => {
        return {
          id: item.value,
          name: item.label,
          param_type_id: item.pathNodes[0].value,
          param_type_name: item.pathNodes[0].label,
          param_sku_id: "",
          param_sku_name: "",
          param_packing_way_id: "",
          param_packing_way_name: "",
          param_custom_code: "",
        };
      });
      this.selectCategory = categroyInfo;
      console.log(this.selectCategory,"选中的类目")
    },
    //获取品牌列表
    getBrandList() {
      let pamars = {
        pageIndex: 0,
        pageSize: 0,
        keyword: "",
      };
      getBrand(pamars).then((res) => {
        console.log('品牌',res)
        if (res.code == 0) {
          this.brandData = res.data.data;
        }
      });
    },
    //获取一级分类列表
    getFirstcatgory() {
      let params = {
        category: "商品,虚拟,活体,医疗,生活服务,医疗服务,套餐",
      };
      firstcatgory(params).then((res) => {
        if (res.code == 0) {
          // console.log('分类列表',res)
          this.firstcatgoryData = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pages {
  background: #fff;
  padding: 20px 20px 0 20px;
  display: flex;
  .titleView {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: solid 1px #f5f5f5;

    .line {
      width: 2px;
      height: 15px;
      background: #1890ff;
      margin-right: 10px;
    }

    .titleName {
      font-size: 16px;
      color: #2a2a2a;
      font-weight: bold;
    }
  }
  .pageLeft {
    padding-right: 20px;
    border-right: solid 1px rgba(0, 0, 0, 0.1);
    padding-bottom: 20px;
    overflow-y: scroll;
  }
  .pageLeft::-webkit-scrollbar {
    display: none;
  }

  .pageRight {
    flex: 1;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    .pageRightView {
      flex: 1;
      overflow-y: auto;
      .comClass {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin: 10px 0;

        .comTitle {
          margin-right: 10px;
        }
      }

      .comView {
        width: 94%;
        min-height: 120px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        padding: 10px 10px 0 10px;

        .comItem {
          margin-right: 6px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          padding: 0 6px 0 10px;
          background: #e6f7ff;
          border: 1px solid #91d5ff;
          line-height: 22px;
          font-size: 12px;
          color: #1890ff;
          display: inline-block;
          border-radius: 2px;

          span:nth-of-type(1) {
            margin-right: 10px;
          }
        }
      }
    }

    .pageRightBtn {
      height: 90px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
  .pageRight::-webkit-scrollbar {
    display: none;
  }

  .mt20 {
    margin-top: 20px;
  }

  .w300 {
    width: 300px;
  }

  .w600 {
    width: 500px;
  }

  .reductionTabs {
    display: flex;
    align-items: center;
    margin-left: 100px;
    font-size: 14px;
    margin-bottom: 22px;

    div {
      width: 50px;
      line-height: 24px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      text-align: center;
      border-radius: 2px;
    }

    div:nth-of-type(1) {
      margin-right: 20px;
    }

    .reductionActive {
      background: #f5882a;
      color: #fff;
    }
  }
  .el-form-item__content{
    margin-left: 0 !important;
  }
}
</style>
